import { Order, MeniconLensOrderRequestBody, PatientOrder } from '@/custom/menicon/models';
import apiClient from '@/services/api/client/apiClient';
import { AxiosRequestConfig } from 'axios';
import { GenericService } from '@/services/api/generic.service';

export class MeniconOrderService extends GenericService<Order> {

  constructor() {
    super(`/menicon/v1/orders`);
  }

  async createOrder(body: MeniconLensOrderRequestBody, params: AxiosRequestConfig = {}): Promise<string> {
    return await apiClient.post(this.endpoint, body, params);
  }

  async getReceipt(orderId: string, config: AxiosRequestConfig = {}): Promise<string> {
    // Get browser's timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const data: Blob = await apiClient.get(`${this.endpoint}/${orderId}/receipt`, {
      ...config,
      headers: { 'Accept-Timezone': timezone },
      responseType: 'blob'
    });
    return window.URL.createObjectURL(new Blob([data]));
  }

  async getOrderDetails(orderId: string, config: AxiosRequestConfig = {}): Promise<PatientOrder> {
    const response = await apiClient.get<PatientOrder>(`${this.endpoint}/${orderId}`, config);
    return response.data;
  }
}
